import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const FeaturedArticle = ({ post }) => (
  <Link to={`/blog/${post.slug}`}>
    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
      className="group grid grid-cols-1 lg:grid-cols-2 gap-0 overflow-hidden border border-[#E5E0D8] hover:shadow-xl transition-all"
    >
      <div className="aspect-[16/10] lg:aspect-auto overflow-hidden">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-8 lg:p-12 flex flex-col justify-center">
        <div className="flex items-center gap-3 mb-4">
          <span className="text-xs font-semibold text-[#1E3D66] tracking-wider uppercase px-2 py-1 bg-[#fafaf9]">
            {post.category}
          </span>
          <span className="flex items-center gap-1 text-xs text-[#9CA3AF]">
            <Calendar size={12} /> {post.date}
          </span>
          <span className="flex items-center gap-1 text-xs text-[#9CA3AF]">
            <Clock size={12} /> {post.readTime}
          </span>
        </div>
        <h2
          className="text-xl sm:text-2xl font-bold text-[#0B2A57] mb-3 leading-tight"
          style={{ fontFamily: 'Cabinet Grotesk' }}
        >
          {post.title}
        </h2>
        <p className="text-sm text-[#6B7280] leading-relaxed mb-6">
          {post.excerpt}
        </p>
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#1E3D66] tracking-wider uppercase group-hover:gap-2 transition-all">
          Read Article <ArrowRight size={14} />
        </span>
      </div>
    </motion.div>
  </Link>
);

export default FeaturedArticle;
